import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import BubblesListComponent from "./BubblesListComponent";

class BubblesListContainer extends PureComponent {
  static propTypes = {
    bubbles: PropTypes.array
  };

  render() {
    return <BubblesListComponent {...this.props} />;
  }
}

export default BubblesListContainer;



// WEBPACK FOOTER //
// ./src/components/BubblesList/BubblesListContainer.js